import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const sections = [
  {
    title: "1. General Policy",
    content: [
      'This Refund Policy explains how refunds are handled for services provided by Trevionix LTD ("Company", "we", "our", or "us") through our website, mobile applications, and related services (the "Service").',
      "We aim to provide a fair and transparent experience for all users.",
    ],
  },
  {
    title: "2. Purchases via Apple App Store",
    content: [
      "If you subscribed or made a purchase through the Apple App Store: all payments are processed by Apple; refunds are handled exclusively by Apple; we do not have access to billing or payment details.",
      "To request a refund, you must contact Apple directly: https://reportaproblem.apple.com.",
      "Refunds are subject to Apple's terms and policies.",
    ],
  },
  {
    title: "3. Purchases Made Directly",
    content: [
      "If a payment was made directly to the Company (e.g., via the website), refunds may be considered under the following conditions:",
      "Eligibility: a verified issue materially affected the Service; the request is submitted within 14 days of payment; sufficient proof of purchase is provided.",
      "Refunds are reviewed on a case-by-case basis and are not guaranteed.",
    ],
  },
  {
    title: "4. Non-Refundable Situations",
    content: [
      "Refunds are generally not provided for: change of mind; failure to use the Service; incorrect expectations or misunderstanding of features; issues caused by third-party services; requests submitted after the refund period.",
    ],
  },
  {
    title: "5. Refund Request Process",
    content: [
      "To request a refund for direct payments, contact: Email: support@trevionics.com. Phone: +44 7520 658798.",
      "Please include: your name and contact details, proof of payment, description of the issue. We may request additional information.",
    ],
  },
  {
    title: "6. Review and Decision",
    content: [
      "All requests are reviewed individually.",
      "We reserve the right to: approve or decline a request; request additional documentation; determine eligibility under this Policy.",
    ],
  },
  {
    title: "7. Refund Processing",
    content: [
      "If approved: refunds will be issued via the original payment method where possible; processing may take 5–14 business days.",
    ],
  },
  {
    title: "8. Subscriptions and Cancellation",
    content: [
      "For subscriptions: you may cancel at any time via your account or platform settings; cancellation stops future billing; cancellation does not automatically guarantee a refund.",
      "For App Store subscriptions, manage via your Apple ID settings.",
    ],
  },
  {
    title: "9. Limitation of Liability",
    content: [
      "We are not responsible for: device-related issues; connectivity problems; third-party service disruptions; factors outside our control.",
    ],
  },
  {
    title: "10. Changes to this Policy",
    content: [
      "We may update this Refund Policy at any time.",
      "Updated versions will be posted with a revised date.",
    ],
  },
  {
    title: "11. Contact",
    content: [
      "Trevionix LTD",
      "International House",
      "12 Constance Street",
      "London",
      "E16 2DQ",
      "United Kingdom",
      "Email: support@trevionics.com",
      "Phone: +44 7520 658798",
    ],
  },
];

export default function RefundPage() {
  return (
    <main className="min-h-screen bg-[#0d0d0d]">
      <Navbar />

      <section className="w-full pt-36 pb-16 md:pt-44 md:pb-20 px-6 md:px-10 lg:px-16">
        <p
          className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Legal
        </p>
        <h1
          className="text-4xl md:text-5xl lg:text-[60px] font-extrabold text-white leading-[1.04] tracking-[-0.025em]"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Refund Policy
        </h1>
      </section>

      <section className="w-full px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <div className="max-w-3xl">
          <div className="flex flex-col gap-8 text-white/60 text-base leading-relaxed" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            {sections.map((section) => (
              <div key={section.title}>
                <h2
                  className="text-lg font-bold text-white mb-3"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {section.title}
                </h2>
                {section.content.map((p, i) => (
                  <p key={i} className={i > 0 ? "mt-3" : ""}>{p}</p>
                ))}
              </div>
            ))}
          </div>

          <p className="mt-12 text-xs text-[#6C7278]" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            Last updated: May 2026
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}